import { FC } from "react";

import { useRidesSocketActions } from "@ryde/redux";

/**
 * Null-rendering host for the rides socket subscription. It re-renders alone when the rides row
 * array or the route changes, so `PageContextWrapper` (and its 150+ context consumers) does not.
 *
 * Must be mounted as a SIBLING of `PageContext.Provider`, never a child: it has to resolve the same
 * outer page context the wrapper body resolved historically, or on the live-map page the socket's
 * status updates would silently retarget the `rideMap` row atom instead of the ride one.
 */
export const RidesSocketBridge: FC = () => {
  useRidesSocketActions();

  return null;
};
